import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-manage-compliance',
  templateUrl: './manage-compliance.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./manage-compliance.component.scss']
})
export class ManageComplianceComponent implements OnInit {

  sectionCards: { imagePath: string, description: string ,title:string  }[] = [
    {

      title:'Clone Framework',
      description:'Clone a framework from a multitude of options already available on our database  ',
      imagePath:'../../../../assets/images/clone.svg',
    },
    {
      title:'Map Evidence',
      description:'Define your compliance level based on the date from the system ',
      imagePath:'../../../../assets/images/map.svg',
    },
    {
      title:'Assess Compliance',
      description:'Define your compliance level based on the date from the system',
      imagePath:'../../../../assets/images/assess.svg',
    },
  ]

  constructor() { }


  ngOnInit(): void {

  }

}

